module.exports = __webpack_public_path__ + "img/Profil_VP-Profii_Standard.a5335f17.jpg";